// A sloth, modelled facing +X: a shaggy grey-green rounded body, long curved
// limbs and a flat sleepy face. Ported 1:1 from age-of-mcp's classic sloth.ts,
// restoring its body/head core and the long-curved-limb loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#8a8a6e",
      position: [0, 0.055, 0], scale: [1.1, 1.2, 1] },              // shaggy body
    { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#9a9a7a",
      position: [0.03, 0.092, 0] },                                  // head
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#c4c0a0",
      position: [0.045, 0.088, 0], scale: [0.7, 1, 1] },            // pale face
    { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#3a3228",
      position: [0.052, 0.092, 0.01] },                            // eye patch
    { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#3a3228",
      position: [0.052, 0.092, -0.01] },
  ];
  // Long curved limbs hanging down.
  for (const [x, z] of [[0.025, 0.03], [0.025, -0.03], [-0.025, 0.03], [-0.025, -0.03]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.007, 0.006, 0.06, 4),
      color: "#7a7a60", position: [x!, 0.03, z!], rotation: [0, 0, x! > 0 ? 0.3 : -0.3] });
  }
  return parts;
}

export const sloth = defineModel({
  id: "sloth",
  batchId: "standard",
  name: "Sloth",
  tags: ["creature","sloth","low-poly","age-of-mcp","classic"],
  summary: "Low-poly sloth.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => partsFor(),
  animations: [],
});
